import { defineMessages } from 'react-intl';

export default defineMessages({
  unassignedFallbackMessage: {
    id: 'baukasten.UserAvatar.unassignedFallbackMessage',
    defaultMessage: 'Unassigned',
  },
});
